import React from "react";
import { Icon } from "@iconify/react";

export default function ContractServiceDetail({ serviceDetail, setServiceDetail, isReadOnly = false }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setServiceDetail((prev) => ({ ...prev, [name]: value }));
  };

  const inputClass =
    "w-full h-10 border rounded-lg px-3 text-sm outline-none focus:ring-2 focus:ring-[#E13F57]";
  const textareaClass =
    "w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#E13F57]";

  return (
    <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200 mt-4">
      {/* Header */}
      <h2 className="text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2">
        <Icon icon="mdi:clipboard-text-outline" className="w-5 h-5 text-[#E13F57]" />
        รายละเอียดบริการที่เลือก
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* 🔹 ผู้จองงานเพิ่มเติม */}
        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700">
            ผู้ลงนามเพิ่มเติม
          </label>
          <input
            type="text"
            name="ExtraWorker"
            style={{ fontSize: "14px" }}
            value={serviceDetail.ExtraWorker || ""}
            onChange={handleChange}
            readOnly={isReadOnly}
            disabled={isReadOnly}
            className={`${inputClass} text-[14px]`}
          />
        </div>

        {/* 🔹 รายละเอียดการบริการ */}
        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700 whitespace-nowrap">
            รายละเอียดการบริการที่ระบุในสัญญา
          </label>
          <textarea
            name="ServiceNote"
            style={{ fontSize: "14px" }}
            value={serviceDetail.ServiceNote || ""}
            onChange={handleChange}
            readOnly={isReadOnly}
            disabled={isReadOnly}
            className={`${inputClass} text-[14px] h-[120px]`}
            rows={4}
            maxLength={500}
          />
        </div>
      </div>

      
    </div>
  );
}
